<template>
  <div class="content">
    <!-- 个人信息 -->
    <div class="userInfo">
      <div class="photo">
        <img src="../assets/images/photo.png" alt="" />
      </div>
      <div class="user">
        <span>{{ info.patientName }}</span>
        <span>{{ info.age || "暂无" }}</span>
      </div>
    </div>
    <!-- 住院信息 -->
    <div class="hospital">
      <div class="item">
        <div class="title">住院号码</div>
        <div>{{ info.inHospitalNum || "暂无" }}</div>
      </div>

      <div class="item">
        <div class="title">申请科室</div>
        <div>{{ info.appDepartment || "暂无" }}</div>
      </div>

      <div class="item">
        <div class="title">主要诊断</div>
        <div class="tag">
          <span>{{ info.diagnosis || "暂无" }} </span>
          <img @click="goDiagnosis(info)" src="../assets/images/360view.png" alt="" />
        </div>
      </div>

      <div class="item">
        <div class="title">申请时间</div>
        <div>{{ info.appTime || "暂无" }}</div>
      </div>

      <template v-if="showMore">
        <div class="item">
          <div class="title">患者性别</div>
          <div>{{ info.gender || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">证件号码</div>
          <div>{{ info.idCard || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">家庭地址</div>
          <div>{{ info.address || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">联系方式</div>
          <div>{{ info.contact || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">工作单位</div>
          <div>{{ info.employer || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">病情</div>
          <div>{{ info.condition || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">申请原因</div>
          <div>{{ info.transferReasons || "暂无" }}</div>
        </div>

        <div class="item">
          <div class="title">外转医院</div>
          <div>{{ info.transferHospital || "暂无" }}</div>
        </div>
      </template>

      <div v-if="!showMore" class="item_footer" @click="showMore = !showMore">
        展开显示更多
      </div>
      <div v-else class="item_footer" @click="showMore = !showMore">收起</div>
    </div>
    <!-- 申请内容 -->
    <div class="applyInfo">
      <div class="title">申请内容</div>
      <div class="con">{{info.condition||'无'}}</div>
      <div v-if="info.sign!=1" class="footer">
        <div v-if="info.approveSign==1" class="btn btn1" @click="checkApp(1)">同意</div>
        <div v-if="info.receiveSign==1" class="btn btn2" @click="checkApp(1)">接收</div>
        <div v-if="info.approveSign==1" class="btn btn3" @click="checkApp(2)">拒绝</div>
      </div>
    </div>

    <!-- 审批流程 -->

    <div class="flow" v-if="info.approvalPersonList.length>0">
      <ul>
        <li :key="index" v-for="(item, index) in info.approvalPersonList">
          <div class="circle_selected"></div>
          <div class="box">
            <div class="title">{{item.title}}{{item.status==1?'同意':'拒绝'}}</div>
            <div class="con">{{item.name}}</div>
            <div class="con">{{item.time}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      list: 10,
      info: {
        patientName:'',
        age:'',
        inHospitalNum:'',
        appDepartment:'',
        diagnosis:'',
        appTime:'',
        gender:'',
        idCard:'',
        address:'',
        contact:'',
        employer:'',
        condition:'',
        transferReasons:'',
        transferHospital:'',
        approveSign:'',
        receiveSign:'',
        approveSign:'',
        approvalPersonList:[],
      },
      showMore: false,
      recordId:'',
      userId:""

    };
  },
  watch: {},
  computed: {},
  methods: {
    // 跳转到360视图
    goDiagnosis(info){
      window.location.href=info.url

    },
    //获取信息
    getInfo() {
      let params = {
        recordId: this.recordId,
        userId: this.userId,
      };
      this.$commonAjax(params, "/approve/approve").then((res) => {
        if (res.code == 200) {
          this.info = res.data;
        }
      });
    },
    //审核接口
    checkApp(status){
      let params = {
        "status":status,// 审批状态 1同意/接收，2拒绝
        "userId":this.userId, //用户id
        "recordId":this.recordId//记录id

      }
      this.$commonAjax(params, "/approve/checkApp").then((res) => {
        if (res.code == 200) {
          
        }
      });

    }
  },
  created() {},
  mounted() {
    let {recordId,userId} = this.$route.query
    if(recordId&&userId){
      this.recordId = recordId;
      this.userId = userId
      this.getInfo();
    }else{
        this.$Dialog({ message: 'recordId、userId参数异常' });
      return
    }
    
  },
};
</script>
<style scoped>
.content {
  padding: 0 20px;
}
/* 个人信息 */
.userInfo {
  background: #ffffff;
  display: flex;
  margin-bottom: 70px;
  border-radius: 30px;
  padding: 20px 30px;
  align-items: center;
}

.userInfo .photo {
  width: 120px;
  height: 120px;
}
.userInfo .photo img {
  width: 100%;
  height: 100%;
}
.userInfo .user {
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
  flex: auto;
}
/* 住院信息 */
.hospital {
  background: #ffffff;
  border-radius: 30px;
  box-sizing: border-box;
}
.hospital .item {
  margin-left: 30px;
  padding-right: 30px;
  display: flex;
  justify-content: space-between;
  height: 86px;
  align-items: center;
  border-bottom: 1px solid #dfdee3;
  box-sizing: border-box;
  font-size: 32px;
  color:#838383
}
.hospital .item .title{
  color:#000000
}
.hospital .item:nth-last-child(2) {
  border-bottom: none;
}
.hospital .item_footer {
  border-top: 1px solid #dfdee3;
  height: 86px;
  line-height: 86px;
  margin-left: 0;
  color: #999999;
  font-size: 24px;
}
.hospital .tag span {
  height: 50px;
  display: inline-block;
}
.hospital .tag img {
  width: 150px;
  height: 47px;
  vertical-align: middle;
  margin-left: 10px;
}
/* 申请内容 */
.applyInfo {
  background: #ffffff;
  margin-top: 70px;
  border-radius: 30px;
  padding: 30px;
}
.applyInfo .title {
  text-align: left;
  margin-bottom: 20px;
}
.applyInfo .con {
  text-align: left;
  line-height: 50px;
}
.applyInfo .footer {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.btn {
  padding: 10px 25px;
  text-align: center;
  color: #ffffff;
  border-radius: 10px;
  font-size: 30px;
}
.btn1 {
  background-color: #51ab3f;
  border: 1px solid #51ab3f;
}
.btn2 {
  background-color: #4872c1;
  border: 1px solid #4872c1;
}
.btn3 {
  background-color: #ff5858;
  border: 1px solid #ff5858;
}

/* 审批流程 */
.flow {
  margin-top: 70px;
  border-radius: 20px;
  padding: 30px;
  background: #ffffff;
  text-align: left;
}
.flow li {
  border-left: 5px solid #dfdee3;
  position: relative;
  padding-left: 60px;
  padding-bottom: 30px;
  box-sizing: border-box;
}
.flow li:last-child .circle_selected {
  position: absolute;
  top: 0;
  left: -14px;
  width: 24px;
  height: 24px;
  background: url("../assets/images/icon_circle_none.png") no-repeat 0 0;
  background-size: 24px 24px;
}
.flow .circle_selected {
  position: absolute;
  top: 0;
  left: -18px;
  width: 32px;
  height: 32px;
  background: url("../assets/images/icon_circle_selected.png") no-repeat 0 0;
  background-size: 32px 32px;
}
.flow .box {
  border: 1px solid #dfdee3;
  border-radius: 10px;
  padding: 20px;
}
.flow .title {
  color: #4b9df1;
  font-size: 30px;
  margin-bottom: 20px;
}
.flow .con {
  font-size: 20px;
  color: #999999;
}
</style>